import { ContentBlockType } from "@/models";
import { widthToTailwindFraction } from "@/styles/ThemeObjects";
import { contentBlockTypeToTailwindClasses } from "./contentBlockTypeConvertor";
import {
    pixelsToTailwindClasses,
    styledSystemToTailwindConversionMap,
} from "./conversionMaps";
import { borderRadiusToTailwindClasses } from "./borderRadiusConverter";

type Prefix =
    | "p"
    | "m"
    | "px"
    | "py"
    | "pr"
    | "pl"
    | "pt"
    | "pb"
    | "mx"
    | "my"
    | "mr"
    | "ml"
    | "mt"
    | "mb";
const allowedPrefixes: Prefix[] = [
    "p",
    "m",
    "px",
    "py",
    "pr",
    "pl",
    "pt",
    "pb",
    "mx",
    "my",
    "mr",
    "ml",
    "mt",
    "mb",
];
//TODO: this will be moved to a shared function space

export const widthToTailwindClasses = (theme: any, id?: string) => {
    if(!theme) return [];
    if (
        !!theme?.tailwindClasses?.length &&
        theme.tailwindClasses.some((className) => className.includes("w-"))
    ) {
        return theme.tailwindClasses;
    }

    if (theme.width) {
        return [`w-${widthToTailwindFraction[theme.width]}`];
    }

    return [];
};

const getConversion = (theme: any, prefix: Prefix = "p", type?: string) => {
    // if (type === "BOX") {
    //     console.log(theme[prefix], theme, prefix);
    // }

    if(!theme) return null;
    if (typeof theme[prefix] === "string" && theme[prefix]?.includes("px")) {
        return pixelsToTailwindClasses[theme[prefix]];
    }

    return styledSystemToTailwindConversionMap[theme[`${prefix}`]];
};

export const paddingOrMarginToTailwindClasses = (
    theme: any,
    type?: string,
    id?: string,
) => {
    const themObject = typeof theme === 'string' ? JSON.parse(theme) : theme;
    if('string' === typeof theme){
        console.log('theme', theme, id)
    }
    if(!themObject) return [];
    const tailwindClasses = [];
    for (const pref of allowedPrefixes) {
        if (!themObject?.hasOwnProperty(pref) || !themObject[pref]) continue;
        const conversion = getConversion(themObject, pref, type);

        tailwindClasses.push(`${pref}-${conversion}`);
    }
    return tailwindClasses;
};

const textStyleToTailwindClasses = (theme: any) => {
    if(!theme) return [];
    const textColor = theme.color || theme.textColor || theme.textStyle?.color;
    const alignment = theme.textAlign;
    const tailwindClasses = [];
    if (textColor) {
        tailwindClasses.push(`text-[${textColor}]`);
    }

    if (alignment) {
        tailwindClasses.push(`text-${alignment}`);
    }

    return tailwindClasses;
};

const flexToTailwindClasses = (theme: any) => {
    if(!theme) return [];
    const flexDirection = theme.flexDirection;
    const flexWrap = theme.flexWrap;
    const flexAlign = theme.alignItems;
    const flexJustify = theme.justifyContent;
    const stacking = theme.stacking;

    const tailwindClasses = ["flex", "flex-wrap"];

    if (flexDirection) {
        tailwindClasses.push(`flex-${flexDirection === "row" ? "row" : "col"}`);
    }

    if (flexWrap) {
        tailwindClasses.push(`flex-wrap-${flexWrap}`);
    }

    if (flexAlign) {
        tailwindClasses.push(`items-${flexAlign}`);
    }

    if (flexJustify) {
        tailwindClasses.push(`justify-${flexJustify}`);
    }

    if (stacking === "column") {
        tailwindClasses.push("flex-col");
    }

    if (theme.display === "flex") {
        tailwindClasses.push(`flex`);
    }

    return tailwindClasses;
};



export const themeToTailwindClasses = (
    theme: any,
    contentBlockType: ContentBlockType,
    id?: string,
) => {

    
    const contentBlockTypeTailwindClasses = contentBlockTypeToTailwindClasses(
        contentBlockType,
        theme,
    );
    const tailwindClasses = [
        ...paddingOrMarginToTailwindClasses(theme, contentBlockType, id),
        ...widthToTailwindClasses(theme, id),
        ...textStyleToTailwindClasses(theme),
        ...flexToTailwindClasses(theme),
        ...borderRadiusToTailwindClasses(theme, id),
        ...contentBlockTypeTailwindClasses,
        "text-[var(--text-color)]",
        "bg-[var(--bg-color)]",
        ...(theme?.tailwindClasses || []),
    ];

    return tailwindClasses;
};
